export class GlobalPairExchange {
  idGlobalPair: number;
  idExchange: number;
  usage: number | null;
  timeStart: number | null;
  lastCandle: number | null;

  constructor(
    idGlobalPair: number,
    idExchange: number,
    usage: number | null,
    timeStart: number | null,
    lastCandle: number | null,
  ) {
    this.idGlobalPair = idGlobalPair;
    this.idExchange = idExchange;
    this.usage = usage;
    this.timeStart = timeStart;
    this.lastCandle = lastCandle;
  }

  static fromRaw(raw: any): GlobalPairExchange {
    return new GlobalPairExchange(
      raw.idGlobalPair,
      raw.idExchange,
      raw.usage === null ? null : Number(raw.usage),
      raw.timeStart === null ? null : Number(raw.timeStart),
      raw.lastCandle === null ? null : Number(raw.lastCandle),
    );
  }

  clone(): GlobalPairExchange {
    return new GlobalPairExchange(
      this.idGlobalPair,
      this.idExchange,
      this.usage,
      this.timeStart,
      this.lastCandle,
    );
  }

  toPayload(): any {
    return {
      idGlobalPair: this.idGlobalPair,
      idExchange: this.idExchange,
      usage: this.usage,
      timeStart: this.timeStart,
      lastCandle: this.lastCandle,
    };
  }
} 